export default __webpack_public_path__ + "static/media/bloco_services.3991061f.svg";